import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { AxiosError } from 'axios';
import { ErrorCode } from '~/libs/infrastructure/schemas/czMaxPrice';
import { handleError } from '~/ErrorHandler';
import { flashErrorMessage } from '~/FlashMessage';
import * as downloadFlashMessages from '~/ProductGroupDownloadPopover/DownloadFlashMessages';
import type { ThunkDispatch } from '~/Store';

type ErrorResponseBody = { errors: { code: string }[] };

const errorCodeToMessage: Partial<Record<ErrorCode, string>> = {
	[ErrorCode.RequiresReferenceSettingsErrorCode]: downloadFlashMessages.MissingPackageSizeErrorMessage,
	[ErrorCode.RequiredProductSettingsMissingErrorCode]: downloadFlashMessages.MissingProductSettingsErrorMessage,
	[ErrorCode.ReferenceCountryProductMissingErrorCode]: downloadFlashMessages.MissingReferenceCountryProductErrorMessage,
	[ErrorCode.OnlyOneProductPerCountryErrorCode]: downloadFlashMessages.OnlyOneProductPerCountryErrorMessage,
	[ErrorCode.IllegalPriceTypeSelectedErrorCode]: downloadFlashMessages.IllegalPriceTypeSelectedErrorMessage,
	[ErrorCode.MissingThreeReferenceCountryProductsErrorCode]:
		downloadFlashMessages.MissingThreeReferenceCountryProductsMessage,
};

export function useCzMaxPriceExportError() {
	const dispatch: ThunkDispatch<AnyAction> = useDispatch();
	return (error: unknown) => {
		const axiosError = error instanceof AxiosError ? (error as AxiosError<ErrorResponseBody>) : null;
		const codes: string[] = axiosError?.response?.data?.errors?.map((e) => e.code) ?? [];
		const matchedCode = codes.find((c) => c in errorCodeToMessage) as ErrorCode | undefined;
		if (matchedCode !== undefined) {
			dispatch(flashErrorMessage(errorCodeToMessage[matchedCode]!));
		} else {
			dispatch(handleError(error));
		}
	};
}
